// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__ApScI","dropdown":"Toolbar_dropdown__3LTS7","dropbtn":"Toolbar_dropbtn__30BvA"};